import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Container } from "reactstrap"
import TdsQuarterTable from "./tdsQuarterTable"

const TdsQuarterList = ({ type }) => {
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb
          title={`${type === "tds" ? "TDS Certificates" : "Account Statements"}`}
        />
        <TdsQuarterTable type={type} />
      </Container>
    </div>
  )
}

export default TdsQuarterList
